import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'unauthorized',
    encapsulation: ViewEncapsulation.None,
    template: require('./unauthorized.template.html')
})
export class UnauthorizedComponent {

    constructor() {
    }

    ngOnInit() {
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/error/unauthorized.component.ts